import { render, staticRenderFns } from "./IATContainer.vue?vue&type=template&id=3449cd76"
import script from "./IATContainer.vue?vue&type=script&lang=js"
export * from "./IATContainer.vue?vue&type=script&lang=js"
import style0 from "./IATContainer.vue?vue&type=style&index=0&id=3449cd76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports